import { apiBaseURL } from '../../Utils/ProjectConstants';
import useSWR from 'swr';


export default function useFetchTasks(billingCode) {
    const { data, error } = useSWR(`${apiBaseURL}/api/Reports/TaskIdentification?headId=${billingCode}`);
    return {
        allTasks: data?.data,
        error,
        isLoading: !data && !error,
    }
}
